import React from "react";
import CommissaryLayout from "../../layout/CommissaryLayout";
import { Tabs } from "antd";
// import PurchaseOrder from "./po/PurchaseOrder";
import PurchaseOrder from "./po/PurchaseOrder";
import DeliveryOrder from "./order/DeliveryOrder";
import MerchantOrder from "./merchant-order/MerchantOrder";
import MerchantPOOverview from "./po-overview/MerchantPOOverview";
import ReportFiled from "./report-filed/ReportFiled";

const CommissaryDelivery = () => {
  const items = [
    {
      key: "1",
      label: `Purchase Order`,
      children: <PurchaseOrder />,
    },
    {
      key: "2",
      label: `Receiving`,
      children: <DeliveryOrder />,
    },
    {
      key: "3",
      label: `Delivery`,
      children: <MerchantOrder />,
    },
    {
      key: "4",
      label: `PO Overview`,
      children: <MerchantPOOverview />,
    },
    {
      key: "5",
      label: `Report Filed`,
      children: <ReportFiled />,
    },
  ];

  //   const onChange = (key) => {
  //     console.log(key);
  //   };

  return (
    <CommissaryLayout>
      <Tabs
        defaultActiveKey="1"
        items={items}
        //   onChange={onChange}
      />
    </CommissaryLayout>
  );
};

export default CommissaryDelivery;
